import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
const useOtherDetailText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings.businessDetails.details"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = detailKind => {
      if (detailKind === "formationDate") {
        return t(_temp);
      }
      if (detailKind === "formationState") {
        return t(_temp2);
      }
      if (detailKind === "tin") {
        return t(_temp3);
      }
      if (detailKind === "entityType") {
        return t(_temp4);
      }
      if (detailKind === "phoneNumber") {
        return t(_temp5);
      }
      if (detailKind === "website") {
        return t(_temp6);
      }
      return "Unknown";
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useOtherDetailText;
function _temp($) {
  return $.formationDate;
}
function _temp2($_0) {
  return $_0.formationState;
}
function _temp3($_1) {
  return $_1.tin;
}
function _temp4($_2) {
  return $_2.entityType;
}
function _temp5($_3) {
  return $_3.phoneNumber;
}
function _temp6($_4) {
  return $_4.website;
}